const styles = () => ({
  grey: {
    background: '#fafbfc',
  },

  white: {
    background: '#ffffff',
  },
});

export default styles;
